import { Component, OnInit, ViewChild, OnDestroy, Renderer2 } from '@angular/core';
import { AbstractControl, FormBuilder, UntypedFormArray, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { MessageService } from 'primeng/api';
import { map, takeUntil } from 'rxjs/operators';
import { AppState } from 'src/app/app.state';
import { AdminPageLayoutComponent } from 'src/app/modules/shared/components/admin-page-layout/admin-page-layout.component';
import { AccelaControl, AccelaControlType } from 'src/app/modules/shared/model/accelaControl.model';
import { ContactAddressModel } from 'src/app/modules/shared/model/contactAddressModel.model';
import { ContactModel } from 'src/app/modules/shared/model/contactModel.model';
import { GFilterViewIdRepo } from 'src/app/repo/GFilterViewIds.repo';
import { selectAppSettings } from 'src/app/state/selectors/app-settings.selectors';
import { CustomScriptInjectionService } from 'src/app/modules/shared/services/custom-script-injection.service';
import { selectAccountSubmission } from 'src/app/state/selectors/public-user-account.selectors';
import { Subject } from 'rxjs';
import { AAExpressionService } from 'src/app/modules/shared/services/aaexpression-service.service';
import { ExpressionResponse } from 'src/app/modules/shared/model/expressions.model';
import { AccountService } from 'src/app/modules/shared/services/account.service';
import { NavigationService } from 'src/app/modules/shared/services/navigation-service.service';
import { PageLayoutService } from 'src/app/modules/shared/services/page-layout.service';
import { SettingService } from 'src/app/modules/shared/services/setting.service';
import { PublicAccountSubmission } from 'src/app/modules/shared/model/publicAccountSubmission.model';
import { SharedDataService } from 'src/app/services/shared-data-service.service';
import { ContactInfoService } from 'src/app/modules/shared/services/contact-info.service';
import { SharedData } from 'src/app/modules/shared/model/shared-data.model';
import { ActivatedRoute } from '@angular/router';
import { EncryptionService } from 'src/app/modules/shared/services/encryption.service';

@Component({
  selector: 'contact-details-screen',
  templateUrl: './contact-details-screen.component.html',
  styleUrls: ['./contact-details-screen.component.css']
})
export class ContactDetailsScreenComponent implements OnInit, OnDestroy {
  @ViewChild('adminDetailLayout') adminDetailLayout: AdminPageLayoutComponent;
  @ViewChild('adminAddressLayout') adminAddressLayout: AdminPageLayoutComponent;

  adminMode = false;
  ContactForm: UntypedFormGroup;
  ContactAddresses: UntypedFormGroup[] = new Array<UntypedFormGroup>();

  controlTypes = AccelaControlType;
  simpleViewElements: AccelaControl[];
  Contact = new ContactModel();
  module = '';
  detailViewId = GFilterViewIdRepo.RegistrationContactForm;
  addressViewId = GFilterViewIdRepo.RegistrationContactAddressForm;
  permissionLevel = 'People';
  addressText: string;
  onLoadExpression: ExpressionResponse;
  onSubmitExpression: ExpressionResponse;
  executeFieldData: ExpressionResponse[];
  executeFields = new Array<string>();
  hideFields: Array<string> = [
    'txtAppStreetAdd1',
    'txtAppStreetAdd2',
    'txtAppStreetAdd3',
    'txtAppCity',
    'ddlAppCountry',
    'txtAppFax',
    'txtAppState',
    'txtAppZipApplicant'
  ];
  isContactAddressEnabled = false;
  currentStep = 2;
  maxStep = 2;
  stepLogicLoaded = false;
  availableTypes: string[];
  sharedData: SharedData;
  processing = false; //block the UI during big operations
  protected destroyActions = new Subject<boolean>();

  constructor(private store: Store<AppState>, private pageLayoutService: PageLayoutService, public navigationService: NavigationService,
    private accountService: AccountService, private formBuilder: FormBuilder, private settingService: SettingService,
    private messageService: MessageService, private expressionService: AAExpressionService,private renderer: Renderer2,
    private customScriptService: CustomScriptInjectionService, private contactInfoService: ContactInfoService, sharedService: SharedDataService) {
        this.sharedData = sharedService.getData();
    }

  ngOnInit(): void {

    this.store.select(selectAppSettings)
    .pipe(takeUntil(this.destroyActions))
    .subscribe({
      next: settings => {
        if(settings){
          this.adminMode = settings.AdminMode;
          if(settings.licenseRequiredForRegistration){
            this.currentStep+=1;
            this.maxStep+=1;
          }
          this.stepLogicLoaded = true;
        }
        this.ContactForm = this.formBuilder.group({ ContactAddress: this.formBuilder.array([]) });
        this.Contact = new ContactModel();
        if (!this.Contact.Addresses) {
          this.Contact.Addresses = new Array<ContactAddressModel>();
        }

        if(!this.adminMode){
          //Expression loading
          this.fetchExpressions();
        }

        this.ContactForm.markAsUntouched();
        this.ContactForm.markAsPristine();
      },
      error: err => console.log(err)
    });

    this.settingService.isEnableCustomizationPerPage()
      .pipe(takeUntil(this.destroyActions))
      .subscribe(res => {
        if(res){
          this.customScriptService.loadAndRunCustomScriptBlock(this.renderer, document, 'account_register-contact-detail');
        }
    });

    if (this.sharedData.isMultipleContact) {
      this.contactInfoService
        .getContactTypesForMultiContact(this.sharedData.SessionParamterString, this.sharedData.Module, this.sharedData.isMultipleContact)
        .pipe(map(res => {
          this.availableTypes = res;
          this.loadContactForm();
        })).subscribe();
    } else {
      this.contactInfoService.getContactTypes().pipe(map(res => {
        this.availableTypes = res;
        this.loadContactForm();
      })).subscribe();
    }
  }

  fetchExpressions() {
    this.expressionService
      .getExpressionJsScriptOnLoad(this.detailViewId, this.module, this.permissionLevel, this.Contact?.Type, 'anonymous')
      .pipe(takeUntil(this.destroyActions))
      .subscribe(data => {
        this.onLoadExpression = data;
      });
    this.expressionService
      .getExpressionJsScriptOnSubmit(this.detailViewId, this.module, this.permissionLevel, this.Contact?.Type, 'anonymous')
      .pipe(takeUntil(this.destroyActions))
      .subscribe(data => {
        this.onSubmitExpression = data;
    });
  }

  addForm(gfilterId: string) {
    this.pageLayoutService.getDynamicFormData(gfilterId, '', this.permissionLevel, this.Contact?.Type, 'anonymous')
      .pipe(takeUntil(this.destroyActions))
      .subscribe((resp => {
        this.simpleViewElements = resp;
        this.simpleViewElements.forEach(controlData => {
          if (this.isContactAddressEnabled) {
            if (this.hideFields.indexOf(controlData.name) > -1) {
              controlData.display = false;
              controlData.required = false;
            }
          }
          if (controlData.display) {
            if (controlData.optionKey !== '' && !this.adminMode) {
              switch (controlData.optionKey) {
                case 'ContactType':
                  controlData.optionKey = this.Contact.Type;
                  break;
              }
            }
              const abstractControl = new UntypedFormControl(controlData.value);
              this.pageLayoutService.processAccelaControl(controlData, abstractControl);
              this.ContactForm.addControl(controlData.name, abstractControl);
            }

        });
        if (gfilterId === this.detailViewId && this.onLoadExpression) {
          this.expressionService
            .invokeExpression(
              this.onLoadExpression, this.ContactForm)
            .pipe(takeUntil(this.destroyActions))
            .subscribe();
        }
        if(!this.adminMode){

        this.expressionService
        .getExpressionJsScriptForExecute(this.detailViewId, this.module, this.permissionLevel, this.Contact.Type, 'anonymous')
          .pipe(takeUntil(this.destroyActions))
          .subscribe(res => {
            if(res && res.length >0){
              this.executeFieldData = res;
              res.forEach(data => {
                if(data.executeBind ){
                  if(data.inputFields){
                    Object.keys(data.inputFields).forEach(fieldSet => {
                      data.inputFields[fieldSet].forEach(field => {
                        const inputField = this.ContactForm.get(field);
                        if(inputField && !(this.executeFields.findIndex(str => str === field) >= 0)){
                          this.executeFields.push(field);
                        }
                      });
                    });
                  }
                }
              });
            }
          });
        }
      })
        , error => {
          this.processing = false;
          this.messageService.add({
            severity: 'error',
            summary: error,
            closable: false
          });
        });
  }

  invokeExpressionForExecute(event: AbstractControl) {
    if (this.executeFields.findIndex(str => str === event.controlData.name) >= 0) {
      this.executeFieldData.forEach(data => {
        this.executeFields.forEach(field =>{
          let inputField = this.ContactForm.get(field);
          if(!inputField && this.ContactAddresses && this.ContactAddresses.length > 0){
            inputField = this.ContactAddresses[0].get(field);
          }
          if (inputField) {
            const ctrlData = inputField.controlData;
            ctrlData.value = inputField.value;
            data.inputFieldProperties[ctrlData.name] = inputField.controlData;
          }
        });

        this.expressionService.invokeExpression(data, this.ContactForm, null).subscribe();

      });
    }
  }

  getAddressText(idx: number) {
    let addressText = '';
    if (idx > 0) {
      addressText += `<strong>${'ADDRESS'} ${idx}</strong>`;
    } else {
      addressText += `<strong>${'ADDRESS'}</strong>`;
    }
    if (this.getAddressControls().length > 1) {
      addressText += ' | ';
    }
    return addressText;
  }

  addAddressForm() {
    if (this.processing) {
      return;
    }
    this.processing = true;

    this.pageLayoutService.getDynamicFormData(this.addressViewId, '', 'ContactAddress', '', 'anonymous')
      .pipe(takeUntil(this.destroyActions))
      .subscribe((resp => {
        const group = new UntypedFormGroup({});
        resp.filter(c => c.display)
          .forEach(c => {
            if (c.display) {
              if (c.optionKey && c.optionKey !== '') {
                switch (c.optionKey) {
                  case 'ContactType':
                    c.optionKey = this.Contact.Type;
                    break;
                }
              }
            }

          const abstractControl = new UntypedFormControl(c.value);

          this.pageLayoutService.processAccelaControl(c, abstractControl);
          group.addControl(c.name, abstractControl);

          return abstractControl;
        });

        this.ContactAddresses.push(group);
        this.getAddressArray().push(group);
        this.processing = false;
      })
        , error => {
          this.processing = false;
          this.messageService.add({
            severity: 'error',
            summary: error,
            closable: false
          });
        });
  }

  removeAddressForm(index: number) {

    if (index > -1 && !this.adminMode) {
      this.ContactAddresses.splice(index, 1);
      this.getAddressArray().controls.splice(index, 1);
    }
  }

  getAddressArray(): UntypedFormArray {
    if (!this.ContactForm) {
      return null;
    }

    return (this.ContactForm.controls['ContactAddress'] as UntypedFormArray);
  }

  getAddressControls(): UntypedFormArray[] {
    if (!this.ContactForm) {
      return null;
    }

    return (this.ContactForm.controls['ContactAddress'] as UntypedFormArray).controls as UntypedFormArray[];

  }

  onContactTypeChange(value): void {
    if (value) {
      this.Contact.Type = value;
      this.reloadContactForm();
    }
  }

  reloadContactForm() {
    this.ContactForm = null;
    this.ContactForm = this.formBuilder.group({ ContactAddress: this.formBuilder.array([]) });

    if(!this.adminMode){
      this.fetchExpressions();
    }
    this.settingService.isContactAddressEnabled()
      .pipe(takeUntil(this.destroyActions))
      .subscribe((res) => {
        if (res) {
          this.isContactAddressEnabled = true;
          if(this.ContactAddresses){
              this.ContactAddresses = new Array<UntypedFormGroup>();
          }
          if (this.adminMode && this.adminAddressLayout) {
            this.adminAddressLayout.refreshPageLayout();
          } else {
            this.addAddressForm();
          }
          this.loadDetailForm();
        } else {
          this.loadDetailForm();
        }
      });

  }

  loadDetailForm() {
    if (this.adminMode) {
      this.adminDetailLayout.permissionValue = this.Contact.Type;
      this.adminDetailLayout.refreshPageLayout();
    } else {
      this.addForm(this.detailViewId);
    }
  }

  getStepText() {
    return this.stepLogicLoaded
      ? `Step ${this.currentStep} of ${this.maxStep}: Contact Details`
      : ``;
  }

  back(event) {
    if (this.adminMode) {
      return;
    }
    this.navigationService.navigateRoute('account/new');
  }

  validateContactForm(): boolean {
    this.ContactForm.updateValueAndValidity();

    if (!this.Contact) {
      this.Contact = new ContactModel();
    }

    const valid = this.validateForm();
    if (!valid) {
      this.messageService.clear();
      this.processing = false;
      this.messageService.add({
        severity: 'error',
        summary: $localize`Not all fields are filled out correctly. Please check again.`,
        closable: false
      });
      return false;
    }
    return true;
  }

  performSave(){
    this.store.select(selectAccountSubmission)
    .pipe(takeUntil(this.destroyActions))
    .subscribe((account => {
      let submission: PublicAccountSubmission;
      if(account && (account as any).PublicUserAccount){
        submission =
          JSON.parse(JSON.stringify((account as any).PublicUserAccount)); //deep copy as the object cmoming out is immutable
      } else {
        submission = new PublicAccountSubmission();
      }

      if (!submission.Contacts) {
        submission.Contacts = new Array<ContactModel>();
      }
      submission.Contacts.push(this.Contact);
      this.accountService.saveNewAccount(submission)
        .pipe(takeUntil(this.destroyActions))
        .subscribe(url => {
          this.processing = false;
          this.navigationService.navigateLegacyPage('Account/' + url.toString());
        }, err => {
          this.processing = false;

          if (err.error && err.error.Uri) {
            const redirect = err.error.Uri.toString().replace('~/', '');
            this.navigationService.navigateLegacyPage(redirect);
          } else {
            this.messageService.add({
              severity: 'error',
              summary: err.message,
              closable: false
            });
            this.reloadContactForm();
          }

        });
    }));

  }

  submit(event) {
    if(this.adminMode || this.processing){
      return;
    }
    this.processing = true;
    this.mapContactUItoContactModel();

    //Run any submission Expression Scripts
    if(this.onSubmitExpression){
      this.expressionService
        .invokeExpression(this.onSubmitExpression, this.ContactForm)
        .pipe(takeUntil(this.destroyActions))
        .subscribe(()=>{
          const valid = this.validateContactForm();
          if(valid) {
            this.performSave();
          }
        });
    } else {
      const valid = this.validateContactForm();
      if(valid) {
        this.performSave();
      }
}
  }

  validateForm(): boolean {
    let valid = true;
    for (const simpleElemName in this.ContactForm.controls) {
      if ({}.hasOwnProperty.call(this.ContactForm.controls, simpleElemName)) {
        const formControl = this.ContactForm.controls[simpleElemName] as UntypedFormControl;
        if (formControl.validator) {
          formControl.markAsDirty();
        }
        if (formControl.errors && Object.keys(formControl.errors).length > 0) {
          console.log(formControl.errors);
          valid = false;
        }
      }
    }
    if (this.ContactAddresses && this.ContactAddresses.length > 0) {
      this.ContactAddresses.forEach(form => {
        for (const elemName in form.controls) {
          if ({}.hasOwnProperty.call(form.controls, elemName)) {
            const formControl = form.controls[elemName] as UntypedFormControl;
            if (formControl.validator) {
              formControl.markAsDirty();
            }
            if (formControl.errors && Object.keys(formControl.errors).length > 0) {
              console.log(formControl.errors);
              valid = false;
            }
          }
        }
      });
    }

    return valid;
  }

  mapUItoModel(property: string, controlName: string): void {
    if (this.ContactForm.controls[controlName]) {
      this.Contact[property] = this.ContactForm.controls[controlName].value;
    }
  }

  mapContactUItoContactModel(): void {
    this.mapUItoModel('salutation', 'ddlAppSalutation');
    this.mapUItoModel('email', 'txtAppEmail');
    this.mapUItoModel('businessName', 'txtAppOrganizationName');
    this.mapUItoModel('businessName2', 'txtBusinessName2');
    this.mapUItoModel('tradeName', 'txtAppTradeName');
    this.mapUItoModel('fein', 'txtAppFein');
    this.mapUItoModel('firstName', 'txtAppFirstName');
    this.mapUItoModel('lastName', 'txtAppLastName');
    this.mapUItoModel('fullName', 'txtAppFullName');
    this.mapUItoModel('middleName', 'txtAppMiddleName');
    this.mapUItoModel('title', 'txtTitle');
    this.mapUItoModel('salutation', 'ddlAppSalutation');
    this.mapUItoModel('socialSecurityNumber', 'txtSSN');
    this.mapUItoModel('streetName', 'txtStreetName');
    this.mapUItoModel('birthDate', 'txtAppBirthDate');
    this.mapUItoModel('genderIdentity', 'radioListAppGender');
    this.mapUItoModel('phone1', 'txtAppPhone1');
    this.mapUItoModel('phone2', 'txtAppPhone2');
    this.mapUItoModel('phone3', 'txtAppPhone3');
    this.mapUItoModel('fax', 'txtAppFax');
    this.mapUItoModel('namesuffix', 'txtAppSuffix');
    this.mapUItoModel('city', 'txtAppCity');
    this.mapUItoModel('addressLine1', 'txtAppStreetAdd1');
    this.mapUItoModel('addressLine2', 'txtAppStreetAdd2');
    this.mapUItoModel('addressLine3', 'txtAppStreetAdd3');
    this.mapUItoModel('state', 'txtAppState');
    this.mapUItoModel('zip', 'txtAppZipApplicant');
    this.mapUItoModel('countryCode', 'ddlAppCountry');
    this.mapUItoModel('birthCity', 'txtBirthplaceCity');
    this.mapUItoModel('deceasedDate', 'txtDeceasedDate');
    this.mapUItoModel('passportNumber', 'txtPassportNumber');
    this.mapUItoModel('driverLicenseNbr', 'txtDriverLicenseNumber');
    this.mapUItoModel('driverLicenseState ', 'ddlDriverLicenseState');
    this.mapUItoModel('stateIdNumber','txtStateNumber');
    this.mapUItoModel('ethnicity', 'ddlRace');
    this.mapUItoModel('birthCity ', 'txtBirthplaceCity');
    this.mapUItoModel('birthDate', 'txtAppBirthDate');
    this.mapUItoModel('birthState', 'ddlBirthplaceState');
    this.mapUItoModel('birthRegion', 'ddlBirthplaceCountry');
    this.mapUItoModel('driverLicenseState', 'ddlDriverLicenseState');
    this.mapUItoModel('preferredChannel', 'ddlPreferredChannel');
    this.mapUItoModel('comment', 'txtNotes');
    this.mapUItoModel('countryCode', 'ddlAppCountry');
    this.mapUItoModel('postOfficeBox', 'txtAppPOBox');
    this.mapUItoModel('auditStatus', 'A');
    this.mapUItoModel('primaryAddressFlag', 'ckbPrimary'); // TODO: Is this the primaryContact?
    this.mapUItoModel('contactSeqNumber', 'hdnContactSeqNumber');

    this.Contact.Addresses = new Array<ContactAddressModel>();

    this.ContactAddresses.forEach(addressForm => {
      const model = new ContactAddressModel();
      this.mapUItoAddressModel('addressType', addressForm.controls['ddlAddressType'], model);
      this.mapUItoAddressModel('effectiveDate', addressForm.controls['txtStartDate'], model);
      this.mapUItoAddressModel('expirationDate', addressForm.controls['txtEndDate'], model);
      this.mapUItoAddressModel('recipient', addressForm.controls['txtRecipient'], model);
      this.mapUItoAddressModel('fullAddress', addressForm.controls['txtFullAddress'], model);
      this.mapUItoAddressModel('addressLine1', addressForm.controls['txtAddressLine1'], model);
      this.mapUItoAddressModel('addressLine2', addressForm.controls['txtAddressLine2'], model);
      this.mapUItoAddressModel('addressLine3', addressForm.controls['txtAddressLine3'], model);
      this.mapUItoAddressModel('houseNumberStart', addressForm.controls['txtStreetStart'], model);
      this.mapUItoAddressModel('houseNumberEnd', addressForm.controls['txtStreetEnd'], model);
      this.mapUItoAddressModel('streetDirection', addressForm.controls['ddlStreetDirection'], model);
      this.mapUItoAddressModel('streetPrefix', addressForm.controls['txtPrefix'], model);
      this.mapUItoAddressModel('streetName', addressForm.controls['txtStreetName'], model);
      this.mapUItoAddressModel('streetSuffix', addressForm.controls['ddlStreetType'], model);
      this.mapUItoAddressModel('unitType', addressForm.controls['ddlUnitType'], model);
      this.mapUItoAddressModel('unitStart', addressForm.controls['txtUnitStart'], model);
      this.mapUItoAddressModel('unitEnd', addressForm.controls['txtUnitEnd'], model);
      this.mapUItoAddressModel('streetSuffixDirection', addressForm.controls['ddlStreetSuffixDirection'], model);
      this.mapUItoAddressModel('countryCode', addressForm.controls['ddlCountry'], model);
      this.mapUItoAddressModel('city', addressForm.controls['txtCity'], model);
      this.mapUItoAddressModel('state', addressForm.controls['txtState'], model);
      this.mapUItoAddressModel('zip', addressForm.controls['txtZip'], model);
      this.mapUItoAddressModel('phone', addressForm.controls['txtPhone'], model);
      this.mapUItoAddressModel('fax', addressForm.controls['txtFax'], model);
      this.mapUItoAddressModel('primary', addressForm.controls['ckbPrimary'], model); // TODO: Should be N or Y
      this.mapUItoAddressModel('levelPrefix', addressForm.controls['txtLevelPrefix'], model);
      this.mapUItoAddressModel('levelNumberStart', addressForm.controls['txtLevelNbrStart'], model);
      this.mapUItoAddressModel('levelNumberEnd', addressForm.controls['txtLevelNbrEnd'], model);
      this.mapUItoAddressModel('houseNumberAlphaStart', addressForm.controls['txtHouseAlphaStart'], model);
      this.mapUItoAddressModel('houseNumberAlphaEnd', addressForm.controls['txtHouseAlphaEnd'], model);


      this.Contact.Addresses.push(model);

    });

  }

  mapUItoAddressModel(property: string, control: AbstractControl, model: ContactAddressModel): void {
    if (control) {
      model[property] = control.value;
    }
  }

  loadContactForm() {
    if (this.availableTypes.length === 1) {
      this.Contact.Type = this.availableTypes[0];
      this.reloadContactForm();
    }
  }

  ngOnDestroy(): void {
    this.customScriptService.removeTrackedElements();
    this.destroyActions.next();
    this.destroyActions.complete();
  }
}
